<div class="container-fluid">
    <!-- Filters Section -->
    <!-- <div class="card mb-3" [class.d-none]="!showCard">
        <div class="card-header">
            <h5 class="card-title mb-0">
                <i class="fas fa-filter me-2"></i>
                Filtrare
            </h5>
        </div>
        <div class="card-body">
            <div class="row g-3">
                <div class="col-md-3">
                    <label class="form-label">Nume Categorie</label>
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="nameFilter"
                        placeholder="Căutați după nume...">
                </div>
                <div class="col-md-3">
                    <label class="form-label">Status Activ</label>
                    <select class="form-select form-select-sm" [(ngModel)]="activeValue">
                        <option value="-1">--Alegeți--</option>
                        <option value="1">Da</option>
                        <option value="0">Nu</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">Vizibilitate Publică</label>
                    <select class="form-select form-select-sm" [(ngModel)]="publicValue">
                        <option value="-1">--Alegeți--</option>
                        <option value="1">Da</option>
                        <option value="0">Nu</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">Direcție</label>
                    <select class="form-select form-select-sm" [(ngModel)]="selectedDirectieId"
                        (ngModelChange)="onDirectieChange()">
                        <option [value]="null">--Toate Direțiile--</option>
                        <option *ngFor="let directie of directiiList" [value]="directie.id">
                            {{ directie.name }}
                        </option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label class="form-label">Compartiment</label>
                    <select class="form-select form-select-sm" [(ngModel)]="selectedCompartimentId"
                        (ngModelChange)="onCompartimentChange()"
                        [disabled]="!selectedDirectieId || compartimenteList.length === 0">
                        <option [value]="null">--Toate Compartimentele--</option>
                        <option *ngFor="let compartiment of compartimenteList" [value]="compartiment.id">
                            {{ compartiment.name }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="d-flex gap-2">
                        <button type="button" class="btn btn-primary btn-sm" (click)="applyFilters()"
                            [disabled]="isLoading">
                            <i class="fas fa-search me-1"></i>
                            Aplică Filtre
                        </button>
                        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetForm()">
                            <i class="fas fa-undo me-1"></i>
                            Resetează
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <!-- Main Content -->
    <!-- <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">
                <i class="fas fa-list me-2"></i>
                Lista Categoriilor
            </h5>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="toggleCard()">
                <i class="fas" [class.fa-chevron-up]="showCard" [class.fa-chevron-down]="!showCard"></i>
                {{ showCard ? 'Ascunde' : 'Afișează' }} Filtre
            </button>
        </div>
        <div class="card-body">
            <div *ngIf="isLoading" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Se încarcă...</span>
                </div>
                <p class="mt-2 text-muted">Se încarcă categoriile...</p>
            </div>

            <div class="table-responsive" [class.d-none]="isLoading">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table w-100">
                </table>
            </div>
        </div>
    </div> -->
</div>

<!-- Statistics Cards -->
<div class="row mb-4" *ngIf="statistics && Object.keys(statistics).length > 0">
    <div class="col-md-3">
        <div class="card bg-primary text-white">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <div>
                        <h6 class="card-title">Total Categorii</h6>
                        <h4>{{ statistics.total_categories || 0 }}</h4>
                    </div>
                    <i class="fas fa-folder-open fa-2x opacity-75"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card bg-success text-white">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <div>
                        <h6 class="card-title">Template-uri Oficiale</h6>
                        <h4>{{ statistics.total_document_templates || 0 }}</h4>
                    </div>
                    <i class="fas fa-file-alt fa-2x opacity-75"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card bg-info text-white">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <div>
                        <h6 class="card-title">Template-uri Cereri</h6>
                        <h4>{{ statistics.total_request_templates || 0 }}</h4>
                    </div>
                    <i class="fas fa-file-text fa-2x opacity-75"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-3">
        <div class="card bg-warning text-white">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <div>
                        <h6 class="card-title">Necategorizate</h6>
                        <h4>{{ statistics.uncategorized_templates || 0 }}</h4>
                    </div>
                    <i class="fas fa-exclamation-triangle fa-2x opacity-75"></i>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Tree View Section -->
<div class="card mb-3" *ngIf="showTreeView">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="card-title mb-0">
            <i class="fas fa-sitemap me-2"></i>
            Structura Categoriilor
        </h5>
        <button *ngIf="showTreeView" type="button" class="btn btn-outline-primary ms-1" (click)="toggleTreeView()"
            [disabled]="isLoading">
            <i class="fas fa-sitemap"></i>
            Ascunde Structura
        </button>
    </div>
    <div class="card-body">
        <div *ngIf="isTreeLoading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Se încarcă...</span>
            </div>
        </div>
        <div *ngIf="!isTreeLoading && categoryTree.length === 0" class="text-center py-4 text-muted">
            <i class="fas fa-folder-open fa-3x mb-2"></i>
            <p>Nu există categorii pentru filtrele selectate</p>
        </div>
        <app-template-category-tree *ngIf="!isTreeLoading && categoryTree.length > 0" [treeData]="categoryTree"
            [allowSelection]="false" [showTemplateCount]="true" (categorySelected)="$event">
        </app-template-category-tree>
    </div>
</div>


<div class="section position-relative">
    <div class="section-top">
        <h3 class="section-title">Categorii Template-uri</h3>
        <div class="section-top-actions">
            <button type="button" class="btn btn-sm btn-info pull-right ms-1" (click)="rerenderDT(false)">
                <i class="fa-solid fa-arrows-rotate"></i>
            </button>
            <button *ngIf="permissionsService.hasPermission('dgaspc-module.settings.template-categories.create')"
                type="button" class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                <i class="fa-solid fa-plus"></i>
                Adaugă
            </button>
            <button *ngIf="!showTreeView" type="button" class="btn btn-outline-primary ms-1" (click)="toggleTreeView()"
                [disabled]="isLoading">
                <i class="fas fa-sitemap"></i>
                Afișează Structura
            </button>
            <button type="button" class="btn btn-outline-info ms-1" (click)="openOrganizationBrowser()"
                [disabled]="isLoading">
                <i class="fas fa-search"></i>
                Browser Template-uri
            </button>
            <button *ngIf="statistics.uncategorized_templates > 0" type="button" class="btn btn-outline-warning ms-1"
                (click)="migrateExistingTemplates()"
                title="Migrează template-urile existente în structura de categorii">
                <i class="fas fa-database me-1"></i>
                Migrează Template-uri
            </button>
        </div>
    </div>

    <div class="card-container p-2" *ngIf="showCard">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>Activ</mat-label>
                    <mat-select [(ngModel)]="activeValue" (change)="rerenderDT()">
                        <mat-option *ngFor="let param of parameters" [value]="param.value" (change)="rerenderDT()">
                            {{ param.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-md-6">
                <mat-form-field class="w-100">
                    <mat-label>Public</mat-label>
                    <mat-select [(ngModel)]="publicValue" (change)="rerenderDT()">
                        <mat-option *ngFor="let param of parameters" [value]="param.value">
                            {{ param.key }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <form [formGroup]="searchParamsForm">
            <div class="row">

                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Nume</mat-label>
                        <input matInput type="text" formControlName="name" />
                    </mat-form-field>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Direcție/Instituție</mat-label>
                        <mat-select formControlName="directie_id" (openedChange)="onDirectieSelectClosed()"
                            (selectionChange)="onDirectieChange($event.value)">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="directiiControl" (keydown)="$event.stopPropagation()"
                                    (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredDirectii.length === 0" disabled>
                                <span>No results found</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let directie of filteredDirectii" [value]="directie.id">
                                {{ directie.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="w-100">
                        <mat-label>Compartiment/Serviciu</mat-label>
                        <mat-select (openedChange)="onCompartimenteSelectClosed()" formControlName="compartiment_id">
                            <mat-form-field class="px-2 w-100 sticky-input">
                                <input matInput [formControl]="compartimenteControl"
                                    (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                            </mat-form-field>

                            <mat-option *ngIf="filteredCompartimente.length === 0" disabled>
                                <span>No results found</span>
                            </mat-option>

                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                            <mat-option *ngFor="let compartiment of filteredCompartimente" [value]="compartiment.id">
                                {{ compartiment.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </form>

        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
            <div class="spinner position-absolute top-50 start-50 translate-middle">
                <mat-spinner></mat-spinner>
                <h3 class="mt-2">
                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                </h3>
            </div>
        </div>

        <div class="row w-100">
            <div class="col d-flex justify-content-start">
                <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning closeBtn">Închide</button>
            </div>
            <div class="col buttons-submit">
                <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                    Resetează
                </button>
                <button (click)="applyFilters()" type="button" class="btn btn-sm btn-primary ms-2">
                    Aplică
                </button>
            </div>
        </div>
    </div>
    <div class="col-sm-12 ps-3">
        <button type="button" class="btn btn-sm btn-default" (click)="toggleCard()" [class.active]="showCard">
            <i class="fa-solid fa-filter"></i> Filtre
        </button>
    </div>
    <div class="table-container position-relative">
        <table id="datatable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
        </table>
    </div>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>